import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-impuesto2cat',
  templateUrl: './main-impuesto2cat.component.html',
  styleUrls: ['./main-impuesto2cat.component.css']
})
export class MainImpuesto2catComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
